import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setCaptchaReturnModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import { IProps } from 'components/CaptchaReturnModal/types';
import Modal from 'components/Modal';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';

const CaptchaReturnModal: React.FC<IProps> = (props) => {
  const handleConfirm = () => {
    handleClose();
  };

  const handleClose = () => {
    props.setCaptchaReturnModalVisible(false);
  };

  return (
    <>
      {props.modal.captchaReturnModalVisible && (
        <Modal
          visible={props.modal.captchaReturnModalVisible}
          icon={SweetAlertIcon.Info}
          title="驗證碼錯誤"
          confirmButtonText="返回"
          cancelButton={false}
          closeIcon={false}
          onConfirm={handleConfirm}
          onCancel={handleClose}
        >
          <p>返回上一頁重新填寫</p>
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setCaptchaReturnModalVisible: (visible: boolean) => dispatch(setCaptchaReturnModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(CaptchaReturnModal);
